/* eslint-disable import/prefer-default-export */
export const PATRON_NOTICE_PATH = {
  CATEGORY: 'category',
  LOCALIZED_TEMPLATES_EN_HEADER: 'localizedTemplates.en.header',
  LOCALIZED_TEMPLATES_EN_BODY: 'localizedTemplates.en.body',
};
